"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrowL = void 0;
exports.arrowL = {
    path: "M13.0871 6.175L11.9121 5L6.91211 10L11.9121 15L13.0871 13.825L9.27044 10L13.0871 6.175Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
